import * as COUNTRIES_LABELS from "../labels/countries";

export const LABELS = {
    [COUNTRIES_LABELS.COUNTRIES_GN]: "几内亚",
    [COUNTRIES_LABELS.COUNTRIES_GW]: "几内亚比绍",
    [COUNTRIES_LABELS.COUNTRIES_YE]: "也门",
    [COUNTRIES_LABELS.COUNTRIES_TR]: "土耳其",
    [COUNTRIES_LABELS.COUNTRIES_TM]: "土库曼斯坦",
    [COUNTRIES_LABELS.COUNTRIES_MV]: "马尔代夫",
    [COUNTRIES_LABELS.COUNTRIES_YT]: "马约特",
    [COUNTRIES_LABELS.COUNTRIES_MT]: "马耳他",
    [COUNTRIES_LABELS.COUNTRIES_MY]: "马来西亚",
    [COUNTRIES_LABELS.COUNTRIES_MG]: "马达加斯加",
    [COUNTRIES_LABELS.COUNTRIES_ML]: "马里",
    [COUNTRIES_LABELS.COUNTRIES_MK]: "马其顿",
    [COUNTRIES_LABELS.COUNTRIES_MW]: "马拉维",
    [COUNTRIES_LABELS.COUNTRIES_MH]: "马绍尔群岛",
    [COUNTRIES_LABELS.COUNTRIES_MQ]: "马提尼克",
    [COUNTRIES_LABELS.COUNTRIES_BT]: "不丹",
    [COUNTRIES_LABELS.COUNTRIES_CN]: "中国",
    [COUNTRIES_LABELS.COUNTRIES_HK]: "中国香港特别行政区",
    [COUNTRIES_LABELS.COUNTRIES_MO]: "中国澳门特别行政区",
    [COUNTRIES_LABELS.COUNTRIES_CF]: "中非共和国",
    [COUNTRIES_LABELS.COUNTRIES_DK]: "丹麦",
    [COUNTRIES_LABELS.COUNTRIES_UG]: "乌干达",
    [COUNTRIES_LABELS.COUNTRIES_UA]: "乌克兰",
    [COUNTRIES_LABELS.COUNTRIES_UY]: "乌拉圭",
    [COUNTRIES_LABELS.COUNTRIES_UZ]: "乌兹别克斯坦",
    [COUNTRIES_LABELS.COUNTRIES_GM]: "冈比亚",
    [COUNTRIES_LABELS.COUNTRIES_EC]: "厄瓜多尔",
    [COUNTRIES_LABELS.COUNTRIES_ER]: "厄立特里亚",
    [COUNTRIES_LABELS.COUNTRIES_BB]: "巴巴多斯",
    [COUNTRIES_LABELS.COUNTRIES_PG]: "巴布亚新几内亚",
    [COUNTRIES_LABELS.COUNTRIES_BR]: "巴西",
    [COUNTRIES_LABELS.COUNTRIES_PY]: "巴拉圭",
    [COUNTRIES_LABELS.COUNTRIES_BH]: "巴林",
    [COUNTRIES_LABELS.COUNTRIES_BS]: "巴哈马",
    [COUNTRIES_LABELS.COUNTRIES_PA]: "巴拿马",
    [COUNTRIES_LABELS.COUNTRIES_PS]: "巴勒斯坦领土",
    [COUNTRIES_LABELS.COUNTRIES_PK]: "巴基斯坦",
    [COUNTRIES_LABELS.COUNTRIES_KY]: "开曼群岛",
    [COUNTRIES_LABELS.COUNTRIES_BN]: "文莱",
    [COUNTRIES_LABELS.COUNTRIES_JP]: "日本",
    [COUNTRIES_LABELS.COUNTRIES_BE]: "比利時",
    [COUNTRIES_LABELS.COUNTRIES_MU]: "毛里求斯",
    [COUNTRIES_LABELS.COUNTRIES_MR]: "毛里塔尼亚",
    [COUNTRIES_LABELS.COUNTRIES_JM]: "牙买加",
    [COUNTRIES_LABELS.COUNTRIES_BJ]: "贝宁",
    [COUNTRIES_LABELS.COUNTRIES_TL]: "东帝汶",
    [COUNTRIES_LABELS.COUNTRIES_TD]: "乍得",
    [COUNTRIES_LABELS.COUNTRIES_IL]: "以色列",
    [COUNTRIES_LABELS.COUNTRIES_GH]: "加纳",
    [COUNTRIES_LABELS.COUNTRIES_IC]: "加纳利群岛",
    [COUNTRIES_LABELS.COUNTRIES_CA]: "加拿大",
    [COUNTRIES_LABELS.COUNTRIES_GA]: "加蓬",
    [COUNTRIES_LABELS.COUNTRIES_MP]: "北马里亚纳群岛",
    [COUNTRIES_LABELS.COUNTRIES_QA]: "卡塔尔",
    [COUNTRIES_LABELS.COUNTRIES_RW]: "卢旺达",
    [COUNTRIES_LABELS.COUNTRIES_LU]: "卢森堡",
    [COUNTRIES_LABELS.COUNTRIES_CU]: "古巴",
    [COUNTRIES_LABELS.COUNTRIES_TW]: "台湾",
    [COUNTRIES_LABELS.COUNTRIES_SM]: "圣马力诺",
    [COUNTRIES_LABELS.COUNTRIES_BL]: "圣巴泰勒米",
    [COUNTRIES_LABELS.COUNTRIES_VC]: "圣文森特和格林纳丁斯",
    [COUNTRIES_LABELS.COUNTRIES_LC]: "圣卢西亚",
    [COUNTRIES_LABELS.COUNTRIES_PM]: "圣皮埃尔和密克隆群岛",
    [COUNTRIES_LABELS.COUNTRIES_ST]: "圣多美和普林西比",
    [COUNTRIES_LABELS.COUNTRIES_CX]: "圣诞岛",
    [COUNTRIES_LABELS.COUNTRIES_KN]: "圣基茨和尼维斯",
    [COUNTRIES_LABELS.COUNTRIES_SH]: "圣赫勒拿",
    [COUNTRIES_LABELS.COUNTRIES_NE]: "尼日尔",
    [COUNTRIES_LABELS.COUNTRIES_NG]: "尼日利亚",
    [COUNTRIES_LABELS.COUNTRIES_NI]: "尼加拉瓜",
    [COUNTRIES_LABELS.COUNTRIES_NP]: "尼泊尔",
    [COUNTRIES_LABELS.COUNTRIES_BF]: "布基纳法索",
    [COUNTRIES_LABELS.COUNTRIES_BI]: "布隆迪",
    [COUNTRIES_LABELS.COUNTRIES_GP]: "瓜德罗普",
    [COUNTRIES_LABELS.COUNTRIES_WF]: "瓦利斯和富图纳",
    [COUNTRIES_LABELS.COUNTRIES_VU]: "瓦努阿图",
    [COUNTRIES_LABELS.COUNTRIES_BY]: "白俄罗斯",
    [COUNTRIES_LABELS.COUNTRIES_PN]: "皮特凯恩群岛",
    [COUNTRIES_LABELS.COUNTRIES_LT]: "立陶宛",
    [COUNTRIES_LABELS.COUNTRIES_AM]: "亚美尼亚",
    [COUNTRIES_LABELS.COUNTRIES_IQ]: "伊拉克",
    [COUNTRIES_LABELS.COUNTRIES_IR]: "伊朗",
    [COUNTRIES_LABELS.COUNTRIES_EA]: "休达及梅利利亚",
    [COUNTRIES_LABELS.COUNTRIES_GU]: "关岛",
    [COUNTRIES_LABELS.COUNTRIES_IS]: "冰岛",
    [COUNTRIES_LABELS.COUNTRIES_LI]: "列支敦士登",
    [COUNTRIES_LABELS.COUNTRIES_CG]: "刚果（布）",
    [COUNTRIES_LABELS.COUNTRIES_CD]: "刚果（金）",
    [COUNTRIES_LABELS.COUNTRIES_HU]: "匈牙利",
    [COUNTRIES_LABELS.COUNTRIES_IN]: "印度",
    [COUNTRIES_LABELS.COUNTRIES_ID]: "印度尼西亚",
    [COUNTRIES_LABELS.COUNTRIES_GT]: "危地马拉",
    [COUNTRIES_LABELS.COUNTRIES_KG]: "吉尔吉斯斯坦",
    [COUNTRIES_LABELS.COUNTRIES_DJ]: "吉布提",
    [COUNTRIES_LABELS.COUNTRIES_GY]: "圭亚那",
    [COUNTRIES_LABELS.COUNTRIES_DO]: "多米尼加共和国",
    [COUNTRIES_LABELS.COUNTRIES_DM]: "多米尼克",
    [COUNTRIES_LABELS.COUNTRIES_TG]: "多哥",
    [COUNTRIES_LABELS.COUNTRIES_AI]: "安圭拉",
    [COUNTRIES_LABELS.COUNTRIES_AO]: "安哥拉",
    [COUNTRIES_LABELS.COUNTRIES_AG]: "安提瓜和巴布达",
    [COUNTRIES_LABELS.COUNTRIES_AD]: "安道尔",
    [COUNTRIES_LABELS.COUNTRIES_TK]: "托克劳",
    [COUNTRIES_LABELS.COUNTRIES_TO]: "汤加",
    [COUNTRIES_LABELS.COUNTRIES_BM]: "百慕大",
    [COUNTRIES_LABELS.COUNTRIES_JO]: "约旦",
    [COUNTRIES_LABELS.COUNTRIES_LA]: "老挝",
    [COUNTRIES_LABELS.COUNTRIES_ES]: "西班牙",
    [COUNTRIES_LABELS.COUNTRIES_EH]: "西撒哈拉",
    [COUNTRIES_LABELS.COUNTRIES_BZ]: "伯利兹",
    [COUNTRIES_LABELS.COUNTRIES_CV]: "佛得角",
    [COUNTRIES_LABELS.COUNTRIES_HR]: "克罗地亚",
    [COUNTRIES_LABELS.COUNTRIES_LY]: "利比亚",
    [COUNTRIES_LABELS.COUNTRIES_LR]: "利比里亚",
    [COUNTRIES_LABELS.COUNTRIES_GR]: "希腊",
    [COUNTRIES_LABELS.COUNTRIES_CK]: "库克群岛",
    [COUNTRIES_LABELS.COUNTRIES_CW]: "库拉索",
    [COUNTRIES_LABELS.COUNTRIES_SA]: "沙特阿拉伯",
    [COUNTRIES_LABELS.COUNTRIES_NA]: "纳米比亚",
    [COUNTRIES_LABELS.COUNTRIES_NU]: "纽埃",
    [COUNTRIES_LABELS.COUNTRIES_GQ]: "赤道几内亚",
    [COUNTRIES_LABELS.COUNTRIES_TV]: "图瓦卢",
    [COUNTRIES_LABELS.COUNTRIES_TZ]: "坦桑尼亚",
    [COUNTRIES_LABELS.COUNTRIES_VE]: "委内瑞拉",
    [COUNTRIES_LABELS.COUNTRIES_BD]: "孟加拉国",
    [COUNTRIES_LABELS.COUNTRIES_PW]: "帕劳",
    [COUNTRIES_LABELS.COUNTRIES_SB]: "所罗门群岛",
    [COUNTRIES_LABELS.COUNTRIES_LV]: "拉脱维亚",
    [COUNTRIES_LABELS.COUNTRIES_FR]: "法国",
    [COUNTRIES_LABELS.COUNTRIES_FO]: "法罗群岛",
    [COUNTRIES_LABELS.COUNTRIES_MF]: "法属圣马丁",
    [COUNTRIES_LABELS.COUNTRIES_GF]: "法属圭亚那",
    [COUNTRIES_LABELS.COUNTRIES_PF]: "法属波利尼西亚",
    [COUNTRIES_LABELS.COUNTRIES_TF]: "法属南部领地",
    [COUNTRIES_LABELS.COUNTRIES_PL]: "波兰",
    [COUNTRIES_LABELS.COUNTRIES_PR]: "波多黎各",
    [COUNTRIES_LABELS.COUNTRIES_BA]: "波斯尼亚和黑塞哥维那",
    [COUNTRIES_LABELS.COUNTRIES_JE]: "泽西岛",
    [COUNTRIES_LABELS.COUNTRIES_GI]: "直布罗陀",
    [COUNTRIES_LABELS.COUNTRIES_RO]: "罗马尼亚",
    [COUNTRIES_LABELS.COUNTRIES_KE]: "肯尼亚",
    [COUNTRIES_LABELS.COUNTRIES_FI]: "芬兰",
    [COUNTRIES_LABELS.COUNTRIES_SD]: "苏丹",
    [COUNTRIES_LABELS.COUNTRIES_SR]: "苏里南",
    [COUNTRIES_LABELS.COUNTRIES_DZ]: "阿尔及利亚",
    [COUNTRIES_LABELS.COUNTRIES_AL]: "阿尔巴尼亚",
    [COUNTRIES_LABELS.COUNTRIES_AE]: "阿拉伯联合酋长国",
    [COUNTRIES_LABELS.COUNTRIES_AR]: "阿根廷",
    [COUNTRIES_LABELS.COUNTRIES_OM]: "阿曼",
    [COUNTRIES_LABELS.COUNTRIES_AF]: "阿富汗",
    [COUNTRIES_LABELS.COUNTRIES_AC]: "阿森松岛",
    [COUNTRIES_LABELS.COUNTRIES_AW]: "阿鲁巴",
    [COUNTRIES_LABELS.COUNTRIES_AZ]: "阿塞拜疆",
    [COUNTRIES_LABELS.COUNTRIES_RU]: "俄罗斯",
    [COUNTRIES_LABELS.COUNTRIES_BG]: "保加利亚",
    [COUNTRIES_LABELS.COUNTRIES_GS]: "南乔治亚岛和南桑威齐群岛",
    [COUNTRIES_LABELS.COUNTRIES_AQ]: "南极洲",
    [COUNTRIES_LABELS.COUNTRIES_SS]: "南苏丹",
    [COUNTRIES_LABELS.COUNTRIES_ZA]: "南非",
    [COUNTRIES_LABELS.COUNTRIES_SY]: "叙利亚",
    [COUNTRIES_LABELS.COUNTRIES_KZ]: "哈萨克斯坦",
    [COUNTRIES_LABELS.COUNTRIES_KH]: "柬埔寨",
    [COUNTRIES_LABELS.COUNTRIES_ZW]: "津巴布韦",
    [COUNTRIES_LABELS.COUNTRIES_HN]: "洪都拉斯",
    [COUNTRIES_LABELS.COUNTRIES_BO]: "玻利维亚",
    [COUNTRIES_LABELS.COUNTRIES_KW]: "科威特",
    [COUNTRIES_LABELS.COUNTRIES_CC]: "科科斯（基林）群岛",
    [COUNTRIES_LABELS.COUNTRIES_CI]: "科特迪瓦",
    [COUNTRIES_LABELS.COUNTRIES_XK]: "科索沃",
    [COUNTRIES_LABELS.COUNTRIES_KM]: "科摩罗",
    [COUNTRIES_LABELS.COUNTRIES_TN]: "突尼斯",
    [COUNTRIES_LABELS.COUNTRIES_US]: "美国",
    [COUNTRIES_LABELS.COUNTRIES_UM]: "美国本土外小岛屿",
    [COUNTRIES_LABELS.COUNTRIES_VI]: "美属维京群岛",
    [COUNTRIES_LABELS.COUNTRIES_AS]: "美属萨摩亚",
    [COUNTRIES_LABELS.COUNTRIES_GB]: "英国",
    [COUNTRIES_LABELS.COUNTRIES_IO]: "英属印度洋领地",
    [COUNTRIES_LABELS.COUNTRIES_VG]: "英属维京群岛",
    [COUNTRIES_LABELS.COUNTRIES_DG]: "迪戈加西亚岛",
    [COUNTRIES_LABELS.COUNTRIES_CO]: "哥伦比亚",
    [COUNTRIES_LABELS.COUNTRIES_CR]: "哥斯达黎加",
    [COUNTRIES_LABELS.COUNTRIES_EG]: "埃及",
    [COUNTRIES_LABELS.COUNTRIES_ET]: "埃塞俄比亚",
    [COUNTRIES_LABELS.COUNTRIES_NO]: "挪威",
    [COUNTRIES_LABELS.COUNTRIES_GG]: "根西岛",
    [COUNTRIES_LABELS.COUNTRIES_GD]: "格林纳达",
    [COUNTRIES_LABELS.COUNTRIES_GL]: "格陵兰",
    [COUNTRIES_LABELS.COUNTRIES_GE]: "格鲁吉亚",
    [COUNTRIES_LABELS.COUNTRIES_TH]: "泰国",
    [COUNTRIES_LABELS.COUNTRIES_HT]: "海地",
    [COUNTRIES_LABELS.COUNTRIES_IE]: "爱尔兰",
    [COUNTRIES_LABELS.COUNTRIES_EE]: "爱沙尼亚",
    [COUNTRIES_LABELS.COUNTRIES_TT]: "特立尼达和多巴哥",
    [COUNTRIES_LABELS.COUNTRIES_TC]: "特克斯和凯科斯群岛",
    [COUNTRIES_LABELS.COUNTRIES_TA]: "特里斯坦-达库尼亚群岛",
    [COUNTRIES_LABELS.COUNTRIES_RE]: "留尼汪",
    [COUNTRIES_LABELS.COUNTRIES_PE]: "秘鲁",
    [COUNTRIES_LABELS.COUNTRIES_SO]: "索马里",
    [COUNTRIES_LABELS.COUNTRIES_NF]: "诺福克岛",
    [COUNTRIES_LABELS.COUNTRIES_KI]: "基里巴斯",
    [COUNTRIES_LABELS.COUNTRIES_FM]: "密克罗尼亚",
    [COUNTRIES_LABELS.COUNTRIES_CZ]: "捷克共和国",
    [COUNTRIES_LABELS.COUNTRIES_IM]: "曼岛",
    [COUNTRIES_LABELS.COUNTRIES_VA]: "梵蒂冈",
    [COUNTRIES_LABELS.COUNTRIES_NL]: "荷兰",
    [COUNTRIES_LABELS.COUNTRIES_BQ]: "荷兰加勒比区",
    [COUNTRIES_LABELS.COUNTRIES_SX]: "荷属圣马丁",
    [COUNTRIES_LABELS.COUNTRIES_MZ]: "莫桑比克",
    [COUNTRIES_LABELS.COUNTRIES_LS]: "莱索托",
    [COUNTRIES_LABELS.COUNTRIES_BW]: "博茨瓦纳",
    [COUNTRIES_LABELS.COUNTRIES_CM]: "喀麦隆",
    [COUNTRIES_LABELS.COUNTRIES_AX]: "奥兰群岛",
    [COUNTRIES_LABELS.COUNTRIES_AT]: "奥地利",
    [COUNTRIES_LABELS.COUNTRIES_FJ]: "斐济",
    [COUNTRIES_LABELS.COUNTRIES_SJ]: "斯瓦尔巴特和扬马延",
    [COUNTRIES_LABELS.COUNTRIES_LK]: "斯里兰卡",
    [COUNTRIES_LABELS.COUNTRIES_SZ]: "斯威士兰",
    [COUNTRIES_LABELS.COUNTRIES_SI]: "斯洛文尼亚",
    [COUNTRIES_LABELS.COUNTRIES_SK]: "斯洛伐克",
    [COUNTRIES_LABELS.COUNTRIES_CL]: "智利",
    [COUNTRIES_LABELS.COUNTRIES_KP]: "朝鲜",
    [COUNTRIES_LABELS.COUNTRIES_MM]: "缅甸",
    [COUNTRIES_LABELS.COUNTRIES_PH]: "菲律宾",
    [COUNTRIES_LABELS.COUNTRIES_VN]: "越南",
    [COUNTRIES_LABELS.COUNTRIES_KR]: "韩国",
    [COUNTRIES_LABELS.COUNTRIES_ME]: "黑山共和国",
    [COUNTRIES_LABELS.COUNTRIES_TJ]: "塔吉克斯坦",
    [COUNTRIES_LABELS.COUNTRIES_SN]: "塞内加尔",
    [COUNTRIES_LABELS.COUNTRIES_RS]: "塞尔维亚",
    [COUNTRIES_LABELS.COUNTRIES_SC]: "塞舌尔",
    [COUNTRIES_LABELS.COUNTRIES_SL]: "塞拉利昂",
    [COUNTRIES_LABELS.COUNTRIES_CY]: "塞浦路斯",
    [COUNTRIES_LABELS.COUNTRIES_IT]: "意大利",
    [COUNTRIES_LABELS.COUNTRIES_SG]: "新加坡",
    [COUNTRIES_LABELS.COUNTRIES_NZ]: "新西兰",
    [COUNTRIES_LABELS.COUNTRIES_NC]: "新喀里多尼亚",
    [COUNTRIES_LABELS.COUNTRIES_NR]: "瑙鲁",
    [COUNTRIES_LABELS.COUNTRIES_CH]: "瑞士",
    [COUNTRIES_LABELS.COUNTRIES_SE]: "瑞典",
    [COUNTRIES_LABELS.COUNTRIES_SV]: "萨尔瓦多",
    [COUNTRIES_LABELS.COUNTRIES_WS]: "萨摩亚",
    [COUNTRIES_LABELS.COUNTRIES_PT]: "葡萄牙",
    [COUNTRIES_LABELS.COUNTRIES_FK]: "福克兰群岛",
    [COUNTRIES_LABELS.COUNTRIES_MN]: "蒙古",
    [COUNTRIES_LABELS.COUNTRIES_MS]: "蒙特塞拉特",
    [COUNTRIES_LABELS.COUNTRIES_DE]: "德国",
    [COUNTRIES_LABELS.COUNTRIES_MD]: "摩尔多瓦",
    [COUNTRIES_LABELS.COUNTRIES_MC]: "摩纳哥",
    [COUNTRIES_LABELS.COUNTRIES_MA]: "摩洛哥",
    [COUNTRIES_LABELS.COUNTRIES_LB]: "黎巴嫩",
    [COUNTRIES_LABELS.COUNTRIES_MX]: "墨西哥",
    [COUNTRIES_LABELS.COUNTRIES_AU]: "澳大利亚",
    [COUNTRIES_LABELS.COUNTRIES_ZM]: "赞比亚",
};

export default LABELS;
